// extracted by mini-css-extract-plugin
module.exports = {"layout":"page-header_layout__dvJ2n","hero":"page-header_hero__M3o5z","graphic":"page-header_graphic__thq5L","intro":"page-header_intro__4g6PF"};